<div class="btn_header" id="header_btn">
  <div class="header_logo" id="headerLogo" routerLink=""></div>
    <button class="navbar-toggler" id="trigger-overlay" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <div class="menu_icon"></div>
    </button>
</div>
<div class="">
<nav class="navbar navbar-expand-lg bg-body-tertiary navbar1" id="mobNav">
  <a href="" class="a_kidzee_logo">
  <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_logo.svg" width="15%" class="kidzee_logo_img" alt="">
</a>
    <div class="collapse navbar-collapse nav_body" id="navbarNavDropdown">
       <ul class="navbar-nav ul_content">
        <li class="nav-item">
          <a class="nav-link active menu1" aria-current="page" href="">Home</a>
        </li>
        <li class="nav-sub-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          >
            About Us
          </a>
          <div class="dropdown-menu about_us" id="ab_id" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" routerLink="/legacy" (click)="gotPage()">Legacy</a>
            <a class="dropdown-item" routerLink="/kidzee-advantage" (click)="gotPage()">Kidzee Advantage</a>
            <a class="dropdown-item" routerLink="/vision-and-mission" (click)="gotPage()">Vision & Mission</a>
            <a class="dropdown-item" routerLink="/awards-and-recognition" (click)="gotPage()">Awards & Recognized</a>
          </div>
        </li>
        <li class="nav-sub-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Programmes
          </a>
          <div class="dropdown-menu program" aria-labelledby="navbarDropdownMenuLink" id="target">
            <a class="dropdown-item" routerLink="/playgroup" (click)="gotPage()">Playgroup</a>
            <a class="dropdown-item" routerLink="/nursery" (click)="gotPage()">Nursery</a>
            <a class="dropdown-item" routerLink="/kindergarten" (click)="gotPage()">Kindergarten</a>
            <a class="dropdown-item" routerLink="/teacher-training-programme" (click)="gotPage()">Teacher Training Programme</a>
            <a class="dropdown-item" routerLink="/daycare" (click)="gotPage()">Daycare</a>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link active menu1" aria-current="page" routerLink="/pentemind" (click)="gotPage()">Péntemind</a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link active menu4" aria-current="page" routerLink="Daycare">DayCare</a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link active menu5" aria-current="page" routerLink="/admissions" (click)="gotPage()">Admissions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active menu" aria-current="page" routerLink="/partner-with-kidzee" (click)="gotPage()">Franchise Opportunity</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" routerLink="/locateus" (click)="gotPage()">Locate Us</a>
        </li>

      </ul>
    </div>
</nav>
</div>
<div class="whiteHeader" id="whiteHeader">
    <nav class="nav navbar navbar-expand-lg">
        <div class="container-fluid">
          <div class="navbar-brand">
          </div>
          <div class="menu_icon" data-bs-toggle="collapse" data-bs-target="#navbarNav"></div>
          <div class="collapse navbar-collapse " id="navbarNav">
            <a href="" class="a_kidzee_logo">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_logo.svg" width="15%" class="kidzee_logo_img" alt="">
          </a>
            <ul class="navbar-nav ul_content">
              <li class="nav-item">
                <a class="nav-link active menu1" aria-current="page" href="">Home</a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  About Us
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                  <a class="dropdown-item selectMenu" routerLink="/legacy">Legacy</a>
                  <a class="dropdown-item" routerLink="/kidzee-advantage">Kidzee Advantage</a>
                  <a class="dropdown-item" routerLink="/vision-and-mission">Vision & Mission</a>
                  <a class="dropdown-item" routerLink="/awards-and-recognition">Awards & Recognized</a>
                </div>
              </li>

              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Programmes
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                  <a class="dropdown-item" routerLink="/playgroup">Playgroup</a>
                  <a class="dropdown-item" routerLink="/nursery">Nursery</a>
                  <a class="dropdown-item" routerLink="/kindergarten">Kindergarten</a>
                  <a class="dropdown-item" routerLink="/teacher-training-programme">Teacher Training Programme</a>
                  <a class="dropdown-item" routerLink="/daycare">Daycare</a>
                </div>
              </li>
              <li class="nav-item">
                <a class="nav-link active menu1" aria-current="page" routerLink="/pentemind">Péntemind</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active menu5" aria-current="page" routerLink="/admissions">Admissions</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active menu" aria-current="page" routerLink="/partner-with-kidzee">Franchise Opportunity</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" routerLink="/locateus">Locate Us</a>
              </li>

            </ul>
          </div>
        </div>
      </nav>

</div>
<router-outlet></router-outlet>
<app-footer></app-footer>
